import CanvasFormInputs from './CanvasFormInputs'

export default CanvasFormInputs
